import {DomainObject} from 'shared/store';
import { observable, action, computed, makeObservable } from 'mobx';
import ReportColumn from './ReportColumn';
import FilterRow from './FilterRow';
import _ from 'lodash';
import CustomReportShare from 'main/stores/reports/CustomReportShare';
import {User} from 'main/stores/users';

class CustomReport extends DomainObject {
  id;
  name;
  columns;
  filter;
  employmentRecordsShowHistory;
  shares;
  sharedBy;
  user;

  _relations = {
    columns: [ReportColumn],
    filter: [FilterRow],
    shares: [CustomReportShare],
    sharedBy: User,
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      columns: observable,
      filter: observable,
      employmentRecordsShowHistory: observable,
      shares: observable,
      sharedBy: observable,
      user: observable,
      addShare: action,
      removeShare: action,
      sortedColumns: computed,
      usersWithAccess: computed
    });

    this.merge(other);
  }

  addShare(share) {
    this.shares.push(share);
  }

  removeShare(share) {
    this.shares.remove(_.find(this.shares, {userId: share.userId}));
  }

  get sortedColumns() {
    return _.sortBy(
      this.columns,
      'order'
    );
  }

  get usersWithAccess() {
    const sharedWith = _.map(this.shares, (share) => share.user);
    return [this.user, ...sharedWith];
  }
}

export default CustomReport;
